// extracted by mini-css-extract-plugin
export var phone = "_3j-0";